import useReveal from '../../hooks/useReveal';

export default function Reveal({ as: Tag = 'div', className = '', stagger = false, children, ...rest }) {
  const ref = useReveal();
  const classes = `${stagger ? 'reveal-stagger' : 'reveal'} ${className}`.trim();
  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
}
